<fa-icon [icon]="fonts[icon]"></fa-icon>
